import SeqLogger from '@/mixins/SeqLogger';

export default {
    mixins: [
        SeqLogger
    ],
    data() {
        return {
            inProgressAction: false,
            unsavedChanges: false,
            savingDisabled: false
        };
    },
    created() {
        this.$meta(this.$route);
    },
    mounted() {
        this.addBeforeUnloadEventListener();

        if (this.$broadcast?.user) {
            this.$broadcast.user.onmessage = () => {
                this.inProgressAction = false;
                this.unsavedChanges = false;

                this.removeBeforeUnloadEventListener();
                this.$root.userChangedEvent();
            };
        }

    },
    beforeDestroy() {
        this.removeBeforeUnloadEventListener();

        this.$root.setUserChangeListener();
    },
    beforeRouteLeave(to, _from, next) {
        const logout = to.name === 'Login';

        if (logout) {
            this.inProgressAction = false;
            this.unsavedChanges = false;

            this.removeBeforeUnloadEventListener();
        }

        if (this.unsavedChanges) {
            if (this.savingDisabled) {
                this.displaySavingDisabledPrompt(next);
            }
            else {
                this.displayUnsavedChangesPrompt(next);
            }
        }
        else if (this.inProgressAction) {
            this.displayInProgressActionPrompt(next);
        }
        else {
            next();
        }
    },
    methods: {
        addBeforeUnloadEventListener() {
            window.addEventListener('beforeunload', this.handleRefresh);
        },
        removeBeforeUnloadEventListener() {
            window.removeEventListener('beforeunload', this.handleRefresh);
        },
        setRouteTitle(titleValue) {
            const TITLE = titleValue.split('|');

            TITLE[0] = TITLE[0].trimToLength(100, true);

            this.$root.appPageTitle = TITLE.join(' | ');
            this.$meta(titleValue);
        },
        goToChildRecord(childRecordID, redirectPath) {
            if (!redirectPath) {
                redirectPath = this.$route.path;
            }

            this.$router.push({
                path: `${redirectPath}/${childRecordID}`,
                params: {
                    uid: childRecordID
                }
            });
        },
        handleRefresh(e) {
            if (this.unsavedChanges || this.inProgressAction) {
                e.returnValue = false;
            }
        },
        displayUnsavedChangesPrompt(next) {
            const modalOptions = {
                labels: {
                    ok: 'Save Changes',
                    cancel: 'Discard Changes'
                },
                stack: true
            };

            UIkit.modal.confirm('There are unsaved changes on this page. Would you like to save your changes?', modalOptions)
                .then(() => {
                    this.$root.saveFunction();
                }, () => {
                    next();
                });
        },
        displayInProgressActionPrompt(next) {
            const modalOptions = {
                labels: {
                    ok: 'Yes',
                    cancel: 'No'
                },
                stack: true
            };

            UIkit.modal.confirm('An action is currently in-progress on this page. Are you sure that you want to leave?', modalOptions)
                .then(() => {
                    next();
                }, () => { });
        },
        displaySavingDisabledPrompt(next) {
            const modalOptions = {
                labels: {
                    ok: 'Remain on This Page',
                    cancel: 'Discard Changes'
                },
                stack: true
            };

            UIkit.modal.confirm('There are unsaved changes on this page but saving is currently disabled. Would you like to remain on this page or discard your changes?',
                                modalOptions)
                .then(() => { }, () => {
                    next();
                });
        },
        resetInProgressAction() {
            return new Promise((resolve) => {
                setTimeout(() => {
                    this.inProgressAction = false;

                    resolve(true);
                }, 250);
            });
        },
        resetUnsavedChanges() {
            return new Promise((resolve) => {
                setTimeout(() => {
                    this.unsavedChanges = false;

                    resolve(true);
                }, 250);
            });
        }
    }
};
